export default "__VITE_ASSET__cc8dc083__"